import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data";

export const Footer = () => {
  return (
    <footer id="contact" data-testid="footer-section" className="bg-brand-brown text-brand-bg">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h3 className="font-display font-extrabold text-2xl tracking-tight">
              ALL DONE <span className="text-brand-olive">HANDYMAN</span>
            </h3>
            <p className="mt-3 text-brand-bg/70 max-w-md leading-relaxed">
              Where perfection, flexibility, and true customer understanding come
              together. Joinery, plumbing & electrical — all done to perfection.
            </p>
            <p className="mt-4 text-sm text-brand-bg/60">By {CONTACT.owner}</p>
          </div>

          <div className="md:justify-self-end">
            <p className="font-display font-bold text-lg mb-5">Get in touch</p>
            <div className="space-y-4">
              <a href={CONTACT.phoneRaw} data-testid="footer-phone" className="flex items-center gap-3 hover:text-brand-olive transition-colors">
                <span className="w-10 h-10 rounded-full bg-brand-olive/20 flex items-center justify-center">
                  <Phone size={18} />
                </span>
                <span className="font-semibold">{CONTACT.phoneDisplay}</span>
              </a>
              <a href={CONTACT.emailLink} data-testid="footer-email" className="flex items-center gap-3 hover:text-brand-olive transition-colors">
                <span className="w-10 h-10 rounded-full bg-brand-olive/20 flex items-center justify-center">
                  <Mail size={18} />
                </span>
                <span className="font-semibold break-all">{CONTACT.email}</span>
              </a>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-brand-olive/20 flex items-center justify-center">
                  <MapPin size={18} />
                </span>
                <span className="font-semibold">{CONTACT.area}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-brand-bg/15 flex flex-col sm:flex-row justify-between gap-3 text-sm text-brand-bg/50 pb-20 md:pb-0">
          <p>© {new Date().getFullYear()} All Done Handyman. All rights reserved.</p>
          <p>Salford & surrounding areas · Free estimates (T&amp;Cs apply)</p>
        </div>
      </div>
    </footer>
  );
};
